<template>
  <img :src="src?.default" :alt="$attrs.alt || ''" @error="useFallbackUrl" />
</template>

<script>
import { ref } from 'vue'

export default {
  name: 'AppImage',
  props: {
    src: {
      type: [Object, String, null],
      required: true,
    },
    fallbackName: {
      type: String,
      default: 'original',
    },
    fallback: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const tries = ref(0)
    const useFallbackUrl = (event) => {
      if (tries.value >= 3) {
        return
      }
      // use fallback url if first one failed to load
      const defaultUrl = props.src[props.fallbackName]
      if (event.target.src !== defaultUrl && !event.target.src.endsWith(props.fallback)) {
        event.target.src = defaultUrl
        tries.value += 1
      } else {
        // if fallback failed to load too, load static fallback if any
        if (props.fallback && !event.target.src.endsWith(props.fallback)) {
          event.target.src = props.fallback
          tries.value += 1
        }
      }
    }
    return {
      useFallbackUrl,
    }
  },
}
</script>
